// @flow

import type { DashboardState } from "./types";
import { startRequest, finishRequest } from "@store/utils";

export const setLoading = (state: DashboardState) => () => startRequest(state);

export const onGetAbsenceNowSuccess = (state: DashboardState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    absenceNow: payload,
  };
};

export const onGetAbsenceNowError = (state: DashboardState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    error: payload,
  };
};

export const onGetToolsDashboardSuccess = (state: DashboardState) => ({ payload }: Object) => ({
  ...finishRequest(state),
  error: null,
  overview: {
    ...state.overview,
    ...payload,
  },
});

export const onGetCoronavirusToolsDashboardSuccess = (state: DashboardState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: null,
  overview: {
    ...state.overview,
    targetedReasons: { ...payload },
  },
});

export const onGetActivityFeedDashboardSuccess = (state: DashboardState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    activityFeed: payload,
  };
};

export const onGetFirstCareIndexPageStatistic = (state: DashboardState) => ({ payload }: Object) =>
  startRequest(state);

export const onGetFirstCareIndexPageStatisticSuccess = (state: DashboardState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    firstcareIndexPageStatistic: payload,
  };
};

export const onGetFirstCareIndexPageStatisticError = (state: DashboardState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    error: payload,
  };
};

export const onGetAbsenceNotesSuccess = (state: DashboardState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    absenceNotes: payload,
  };
};

export const onToolsDashboardError = (state: DashboardState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    error: payload,
  };
};

export const onGetHierarchyBreakdownSuccess = (state: DashboardState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    hierarchyBreakdown: payload,
  };
};

export const onGetHierarchyBreakdownError = (state: DashboardState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    error: payload,
    hierarchyBreakdown: [],
  };
};
